export default __webpack_public_path__ + "static/media/Group 280.fb9e216d.svg";